import React from 'react'
import { Switch } from '@mui/material'
import av from '../Assets/av.svg'
import av2 from '../Assets/av-2.png'
import question from '../Assets/question.svg'
import acti from '../Assets/activity.svg'
import sound from '../Assets/sound.svg'
import music from '../Assets/music.svg'
import animation from '../Assets/animation.svg'
import star from '../Assets/star-menu.svg'
import limits from '../Assets/limits.svg'
import rules from '../Assets/rules.svg'
import pf from '../Assets/pf.svg'
import servers from '../Assets/multi-server.svg'
import home from '../Assets/home.svg'

const AviatorDropdown = () => {
  return (
    <div className='aviatorDropdown z-50 bg-[#2c2d30] rounded-lg'>
        <div className='flex justify-between items-center bg-[#2c2d30] p-2'>
            <div className='flex justify-center items-center space-x-2'>
                <img src={av2} className='w-[40px] h-[40px] rounded-full' alt=''/>
                <p className='font-bold text-white'>Meme_86053</p>
            </div>
            <div className='flex space-x-1 bg-[#252528] border border-[#414148] rounded-full p-2 justify-center items-center'>
                <img className='w-[20px] h-[20px]' src={av} alt=''/>
                <p className='text-gray-400'>Change Avatar</p>
            </div>
       </div>   
        <div className='flex flex-col '>
            <div className='bg-[#1b1c1d] flex justify-between items-center px-2 py-1'>
                <div className=' flex space-x-2 items-center'>
                    <img src={sound} alt=''/>
                    <p className=' text-white'>Sound</p>
                </div>
                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
             </div>
             <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center px-2 py-1'>
                <div className='flex space-x-2 items-center'>
                    <img src={music} alt=''/>
                    <p className=' text-white'>Music</p>
                </div>
                <Switch
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
             </div>
             <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center px-2 py-1'>
                <div className='flex space-x-2 items-center'>
                    <img src={animation} alt=''/>
                    <p className=' text-white'>Animation</p>
                </div>
                <Switch value={'off'}
                sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#efefef', // Thumb color when checked
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#2fff00', // Track color when checked
                    },
                    '& .MuiSwitch-track': {
                    backgroundColor: 'gray', // Default track color
                    },'& .MuiSwitch-thumb': {
                        width: 19, // Keep the thumb size same
                        height: 19,
                      },"& .MuiSwitch-track": {
                        border: "1px solid #8d8e8e", // Border for track
                      },
                }}
                />
             </div>
        </div>  
        <div className='flex flex-col mt-5'>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={star} alt=''/>
                    <p className='text-white'>Free Bets</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={acti} alt=''/>
                    <p className='text-white'>My Bet History</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={limits} alt=''/>
                    <p className='text-white'>Game History</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={question} alt=''/>
                    <p className='text-white'>How to Play</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={rules} alt=''/>
                    <p className='text-white'>Game Rules</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={pf} alt=''/>
                    <p className='text-white'>Provably Fair Settings</p>
                </div>
            </div>
            <div className='bg-[#1b1c1d] border-t border-[#323334] flex justify-between items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={servers} alt=''/>
                    <p className='text-white'>Game Room: Room #1</p>
                </div>
            </div>
            <div className='flex justify-center items-center p-2'>
                <div className=' flex space-x-2 items-center'>
                    <img className='w-[16px] h-[16px]' src={home} alt=''/>
                    <p className='text-gray-400'>Home</p>
                </div>
            </div>
        </div>        
    </div>
  )
}

export default AviatorDropdown